import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Button, Typography } from "antd";
import axios from "axios";
import config from "../config";

const { Title } = Typography;

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: "20px",
        color: "#424770",
        fontFamily: "Open Sans, sans-serif",
        letterSpacing: "0.025em",
        lineHeight: "60px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#c23d4b",
      },
    },
  };
};

const Form = (props) => {
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [addonPrice, setAddonPrice] = useState(0);
  const stripe = useStripe();
  const elements = useElements();
  const { stepOne, apiRequest, addon } = useSelector((state) => state);
  const addonSelected = addon?.wanted === true;
  const addonFee = addonSelected ? addonPrice : 0;
  const total = price + addonFee;
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`${config.baseUrl}settings/price`);
      setPrice(data.price);
      setAddonPrice(data.addonPrice || 0);
    })();
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { error, token } = await stripe.createToken(
      elements.getElement(CardElement),
      {
        name: stepOne.name,
      }
    );
    if (error) {
      setLoading(false);
      return error;
    }
    props.incrementStep({ payment: token, addon: addonSelected });
  };

  return (
    <div className="flex vh-90 card-details">
      <div className={"card m-t-10-px"}>
        <Title level={2}>Payment Information</Title>
        <div className="flex details">
          <small style={{ fontWeight: "bold", fontSize: "15px", width: "50%" }}>
            Name
          </small>
          <label style={{ fontWeight: "lighter", fontSize: "20px" }}>
            {`${stepOne.firstName} ${stepOne.middleName || ""} ${
              stepOne.lastName
            }`}
          </label>
        </div>
        <div className="flex details">
          <small style={{ fontWeight: "bold", fontSize: "15px", width: "50%" }}>
            DOB
          </small>
          <label style={{ fontWeight: "lighter", fontSize: "20px" }}>
            {moment(stepOne.dob).format("MM/DD/YYYY")}
          </label>
        </div>
        <div className="flex details">
          <small style={{ fontWeight: "bold", fontSize: "15px", width: "50%" }}>
            Pharmacy
          </small>
          <div className="flex column" style={{ width: "50%" }}>
            <label style={{ fontWeight: "lighter", fontSize: "20px" }}>
              {apiRequest.pharmacy.name}
            </label>
            <label style={{ fontWeight: "lighter", fontSize: "20px" }}>
              {apiRequest.pharmacy.address}
            </label>
          </div>
        </div>
        {/* <Col span={24}>
          <Row>
            <label className={"label"}>Name</label>
            <Input
              placeholder={"Full Name"}
              type="text"
              onChange={(e) => changeForm(e.target.value)}
            />
          </Row>
        </Col> */}
        <label style={{ fontWeight: "bold", fontSize: "20px" }}>
          Credit Card
        </label>
        <CardElement options={{ ...createOptions(), hidePostalCode: true }} />
        <div
          className="order-summary"
          style={{
            margin: "16px 0",
            padding: "12px 0",
            borderTop: "1px solid #eee",
            borderBottom: "1px solid #eee",
          }}
        >
          <div className="flex" style={{ justifyContent: "space-between" }}>
            <span style={{ fontSize: "14px" }}>UTI Treatment Visit</span>
            <span style={{ fontSize: "14px" }}>${price}</span>
          </div>
          {addonSelected && (
            <>
              <div
                className="flex"
                style={{ justifyContent: "space-between", marginTop: "6px" }}
              >
                <span style={{ fontSize: "14px" }}>
                  Symptom Relief Medication (Phenazopyridine)
                </span>
                <span style={{ fontSize: "14px" }}>${addonFee}</span>
              </div>
              <small
                style={{
                  display: "block",
                  fontSize: "12px",
                  color: "#6b7280",
                  marginTop: "4px",
                  lineHeight: 1.4,
                }}
              >
                Pharmacy medication cost may apply separately if not covered by
                insurance.
              </small>
            </>
          )}
          <div
            className="flex"
            style={{
              justifyContent: "space-between",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            <span style={{ fontSize: "15px" }}>Total</span>
            <span style={{ fontSize: "15px" }}>${total}</span>
          </div>
        </div>

        <small className="description-message">{`Please enter your payment information to continue. Your credit card will be charged $${total} and a healthcare professional will review your information to determine if you are a candidate to receive a prescription of antibiotics. If so, you will receive a confirmation email and an electronic prescription will be sent to your pharmacy. If the healthcare provider determines that for safety concerns, you are not a good candidate for this type of online service, you will receive a confirmation email and a full refund will be issued.`}</small>
        <Button
          type="primary"
          disabled={!stripe || loading}
          onClick={(event) => handleSubmit(event)}
          loading={loading}
        >
          Pay ${total}
        </Button>
      </div>
    </div>
  );
};

const Payment = (props) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);
  return (
    <div className="column scroll-y">
      <Elements stripe={stripePromise}>
        <Form incrementStep={props.incrementStep} />
      </Elements>
    </div>
  );
};

export default Payment;
